export const categories = [
  { slug: 'all', name: '全部番号', icon: 'ri-movie-line' },
  { slug: 'latest', name: '最新发布', icon: 'ri-rocket-line' },
  { slug: 'hot', name: '热门推荐', icon: 'ri-fire-line' },
  { slug: 'featured', name: '精选合集', icon: 'ri-star-line' },
  { slug: 'classic', name: '经典回顾', icon: 'ri-vip-crown-line' },
  { slug: 'new-face', name: '新人出道', icon: 'ri-user-star-line' },
  { slug: 'drama', name: '剧情系列', icon: 'ri-clapperboard-line' },
  { slug: 'solo', name: '单体作品', icon: 'ri-user-smile-line' },
];